import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Link} from 'react-router-dom'


const styles = {
  card: {
    maxWidth: 240,
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
};

class TestItem extends React.PureComponent {

  render() {
    const { classes, title, test, test: {project} } = this.props;
    return (
      <Card className={classes.card} elevation={1}>
        <CardActionArea style={{width: '100%'}} component={Link} to={`/test/${test.id}/detail`}>
          <CardMedia
            component="img"
            className={classes.media}
            height="180"
            image="/assets/img/dummy/placeimg_320_320_arch.jpg"
            title="Contemplative Reptile"
          />
          <CardContent>
            <Typography gutterBottom variant="title" noWrap>
              {test.title}
            </Typography>
            <Typography component="p">
              {Array.isArray(project.medical_visits) && project.medical_visits[0] && (
                  <span>Día inicio {project.medical_visits[0].date}</span>
              )}
            </Typography>
            <Typography component="p">
              {Array.isArray(project.medical_visits) && project.medical_visits[1] && (
                  <span>Día fin {project.medical_visits[1].date}</span>
              )}
            </Typography>
            {/*<Typography variant="caption" component="p">*/}
            {/*  23 Setiembre 2018*/}
            {/*</Typography>*/}
          </CardContent>
        </CardActionArea>
      </Card>
    )
  }
}

TestItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TestItem);



// WEBPACK FOOTER //
// ./src/modules/test/components/TestItem.js